export const getBase64ImageFromUrl = (url,logoWidth,logoHeight, callback) => {
  let img = new Image();
  img.crossOrigin = "Anonymous"; // Avoid CORS issues
  img.onload = function () {
    let canvas = document.createElement("canvas");
    canvas.width =logoWidth;
    canvas.height = logoHeight;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let dataURL = canvas.toDataURL("image/png"); // Convert to Base64
    callback(dataURL);
  };
  img.src = url;
};

export const fetchImageAsBase64 = async (imageKey) => {
  console.log("imagekye",imageKey)
  try {
    const imageUrl=`${process.env.REACT_APP_API_REPORT_HOST}/media/${imageKey}`
    const response = await fetch(imageUrl, { mode: "cors" });
    const data = await response.json();
    return data.base64;
  } catch (error) {
    console.error("Error fetching image:", error);
    return null;
  }
};



